import $$ep from 'models/ep';

const CAN_PAY_AT_THE_BEGINNING_THRESHOLD = Date.parse('2022-06-20T11:30:00.000Z');
const SHOW_ASSESSMENT_ON_DASHBOARD_THRESHOLD = Date.parse('2022-08-02T08:00:00.000Z');

const FeatureThresholdService = {
    canPayAtTheBeginning: () => {
        const estatePlan = $$ep.stores.$epQInstance.getState();
        return (estatePlan?.date_added || 0) > CAN_PAY_AT_THE_BEGINNING_THRESHOLD;
    },

    canShowAssessmentOnDashboard: () => {
        const estatePlan = $$ep.stores.$epQInstance.getState();
        return (estatePlan?.date_added || 0) > SHOW_ASSESSMENT_ON_DASHBOARD_THRESHOLD;
    },
};

export default FeatureThresholdService;
